import { render } from "./AssignInstructorModal.vue?vue&type=template&id=6f1ca722&scoped=true"
import script from "./AssignInstructorModal.vue?vue&type=script&lang=js"
export * from "./AssignInstructorModal.vue?vue&type=script&lang=js"

import "./AssignInstructorModal.vue?vue&type=style&index=0&id=6f1ca722&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1ca722"]])

export default __exports__